import { call, put, takeLatest } from "redux-saga/effects";
import {
  onVendorProfileSave,
  onVendorProfileSaveSuccess,
  onVendorProfileSaveError,
  onGetVendorProfile,
  onGetVendorProfileSuccess,
  onGetVendorProfileError,
} from "../Store/Slices/vendorProfileSlice";
import {
  callVendorProfileSaveApi,
  callGetVendorProfileApi,
} from "../Context/businessApi";

function* vendorProfileSaveSaga({ payload }) {
  try {
    const response = yield call(callVendorProfileSaveApi, payload);
    const code = response.httpStatusCode ?? response.status;
    if (code === "200" || code === 200 || code === 201 || code === "201") {
      yield put(
        onVendorProfileSaveSuccess({
          message: response.message || "Vendor profile saved",
          status_code: code,
        })
      );
    } else {
      yield put(
        onVendorProfileSaveError({
          message: response.message || "Save failed",
          status_code: code,
        })
      );
    }
  } catch (error) {
    const message =
      error.response?.data?.message || error.message || "Something went wrong";
    yield put(onVendorProfileSaveError({ message, status_code: 400 }));
  }
}

function* getVendorProfileSaga() {
  try {
    const response = yield call(callGetVendorProfileApi);
    const code = response.httpStatusCode ?? response.status;
    if (code === "200" || code === 200) {
      const data = response.data?.vendor ?? response.data ?? null;
      yield put(
        onGetVendorProfileSuccess({
          data,
          status_code: code,
        })
      );
    } else {
      yield put(
        onGetVendorProfileError({
          data: response.data ?? null,
          status_code: code,
        })
      );
    }
  } catch (error) {
    yield put(onGetVendorProfileError({ data: null, status_code: 400 }));
  }
}

export default function* vendorProfileSaga() {
  yield takeLatest(onVendorProfileSave.type, vendorProfileSaveSaga);
  yield takeLatest(onGetVendorProfile.type, getVendorProfileSaga);
}
